import { useState } from "react";
import { useNavigate } from "react-router-dom";
import StatusBar from "../StatusBar/StatusBar";
import SEO from "../SEO/SEO";
import "./Projects.css";

import GarvanaHome4 from "./images/GarvanaHome4.jpg";
import GarvanaHome3 from "./images/GarvanaHome3.jpg";
import GarvanaHome2 from "./images/GarvanaHome2.jpg";
import GarvanaHome6 from "./images/GarvanaHome6.jpg";
import GarvanaHome7 from "./images/GarvanaHome7.jpg";
import Garden5      from "./images/Garden5.jpg";
import Garden24     from "./images/garvana24.jpeg";
import Garden1      from "./images/Garden1.jpeg";
import Garden2      from "./images/Garden2.webp";
import Garden4      from "./images/Garden4.jpeg";
import Project1      from "../../Components/Gallery/images/image6.jpeg";
import Project2      from "../../Components/Gallery/images/image7.jpeg";
import Project3      from "../../Components/Gallery/images/image8.jpeg";
import Project4      from "../../Components/Gallery/images/image10.jpeg";
import Project5      from "../../Components/Gallery/images/image19.jpeg";
import Project6      from "../../Components/Gallery/images/image20.jpeg";
import Project7      from "../../Components/Gallery/images/image4.jpeg";
import Project8      from "../../Components/Gallery/images/image25.jpeg";
import Project9      from "../../Components/Gallery/images/image26.jpeg";
import Project10      from "../../Components/Gallery/images/image27.jpeg";

const projects = [
  /* ── COMPLETED — 12 projects ─────────────────────────────── */
  {
    id: 1,
    title: "The Elysian Villa Estate",
    client: "Private Residence",
    location: "Sector 57, Gurugram, Haryana",
    type: "Luxury Residential Garden",
    area: "8,500 sq ft",
    startDate: "Jan 2024",
    endDate: "Apr 2024",
    duration: "4 Months",
    year: "2024",
    status: "Completed",
    description:
      "Complete transformation of a private villa estate — Japanese-inspired Zen garden, koi pond, cascading water features, curated exotic plant collections, and artisanal sandstone pathways. Delivered a private sanctuary of serenity and elegance for a discerning homeowner.",
    tags: ["Zen Garden", "Koi Pond", "Exotic Plants", "Villa"],
    image: GarvanaHome4,
  },
  {
    id: 2,
    title: "Grandeur Corporate Campus",
    client: "IT Business Park",
    location: "Sector 62, Noida, UP",
    type: "Commercial Landscaping",
    area: "22,000 sq ft",
    startDate: "Feb 2024",
    endDate: "Jul 2024",
    duration: "6 Months",
    year: "2024",
    status: "Completed",
    description:
      "Green corridors, rooftop ecological gardens, and floor-to-ceiling vertical living walls across a multi-building corporate campus — transforming sterile office spaces into biophilic sanctuaries that boost employee wellness and productivity.",
    tags: ["Corporate", "Vertical Walls", "Rooftop Garden", "Biophilic"],
    image: Project9,
  },
  {
    id: 3,
    title: "Heritage Boutique Resort",
    client: "Boutique Resort",
    location: "Surajkund, Faridabad, Haryana",
    type: "Hospitality Landscaping",
    area: "15,000 sq ft",
    startDate: "May 2023",
    endDate: "Sep 2023",
    duration: "5 Months",
    year: "2023",
    status: "Completed",
    description:
      "Full resort landscape transformation — poolside tropical gardens, illuminated evening pathways, a fragrance garden, and curated seasonal flowering collections. Delivered an immersive luxury hospitality experience that increased guest ratings significantly.",
    tags: ["Resort", "Poolside Garden", "Tropical", "Lighting Design"],
    image: GarvanaHome3,
  },
  {
    id: 4,
    title: "Delhi Heritage Bungalow",
    client: "Heritage Property Owner",
    location: "Lutyens Zone, South Delhi",
    type: "Heritage Garden Restoration",
    area: "6,000 sq ft",
    startDate: "Mar 2023",
    endDate: "Apr 2023",
    duration: "2 Months",
    year: "2023",
    status: "Completed",
    description:
      "Sensitive restoration of a colonial-era bungalow garden in Lutyens Delhi — preserving 80-year-old specimen trees, reintroducing heritage rose varieties and period-appropriate plant collections that honour the property's architectural legacy.",
    tags: ["Heritage", "Restoration", "Colonial Garden", "South Delhi"],
    image: GarvanaHome6,
  },
  {
    id: 5,
    title: "Green Horizon Office Tower",
    client: "Corporate Office",
    location: "Cyber City, Gurugram, Haryana",
    type: "Interior Landscape Design",
    area: "9,500 sq ft",
    startDate: "Mar 2024",
    endDate: "May 2024",
    duration: "3 Months",
    year: "2024",
    status: "Completed",
    description:
      "Interior landscape transformation of premium office floors — curated plant installations, moss art walls, atrium green canopies, and an ongoing maintenance contract. Brings the healing power of nature into the everyday workspace.",
    tags: ["Office Interior", "Moss Walls", "Atrium", "Plant Styling"],
    image: GarvanaHome2,
  },
  {
    id: 6,
    title: "Vrindavan Ashram Garden",
    client: "Spiritual Retreat Centre",
    location: "Vrindavan, Mathura, UP",
    type: "Spiritual Landscape Design",
    area: "7,200 sq ft",
    startDate: "Oct 2023",
    endDate: "Dec 2023",
    duration: "2 Months",
    year: "2023",
    status: "Completed",
    description:
      "Sacred healing garden with Tulsi courtyards, medicinal herb sections, Lotus ponds, and Navagraha tree plantation — designed in alignment with Vedic garden principles to create a spiritually enriching and visually serene environment.",
    tags: ["Spiritual Garden", "Medicinal Herbs", "Lotus Pond", "Mathura"],
    image: Project1,
  },
  {
    id: 7,
    title: "Rajpur Road Mountain Villa",
    client: "Private Residence",
    location: "Rajpur Road, Dehradun, Uttarakhand",
    type: "Mountain Villa Garden",
    area: "5,500 sq ft",
    startDate: "Jun 2023",
    endDate: "Aug 2023",
    duration: "3 Months",
    year: "2023",
    status: "Completed",
    description:
      "Mountain-inspired garden for a luxury villa on Dehradun's Rajpur Road — native Himalayan flora, terraced lawns with retaining stone walls, a naturalistic stream feature, and a panoramic viewing deck framing the valley below.",
    tags: ["Mountain Garden", "Himalayan Flora", "Terraced Lawn", "Dehradun"],
    image: Project2,
  },
  {
    id: 8,
    title: "Jaipur Palace Courtyard",
    client: "Heritage Haveli Hotel",
    location: "Old City, Jaipur, Rajasthan",
    type: "Heritage Courtyard Restoration",
    area: "4,800 sq ft",
    startDate: "Jan 2023",
    endDate: "Feb 2023",
    duration: "2 Months",
    year: "2023",
    status: "Completed",
    description:
      "Mughal-style courtyard restoration within a heritage haveli hotel — symmetrical parterres, rose bowers, terracotta planters, marble water channels, and period fragrance plants including Champa, Mogra, and Harsingar.",
    tags: ["Mughal Garden", "Heritage Hotel", "Courtyard", "Jaipur"],
    image: GarvanaHome7,
  },
  {
    id: 9,
    title: "Noida Sec 44 Luxury Villa",
    client: "Private Residence",
    location: "Sector 44, Noida, UP",
    type: "Luxury Residential Garden",
    area: "6,800 sq ft",
    startDate: "Aug 2023",
    endDate: "Oct 2023",
    duration: "3 Months",
    year: "2023",
    status: "Completed",
    description:
      "Contemporary luxury garden for a modern villa — structured lawn panels, a pergola dining terrace with climbing plants, a private pool deck garden, geometric planter walls, and an automated drip irrigation system with smart timer controls.",
    tags: ["Luxury Villa", "Pool Deck", "Pergola", "Drip Irrigation"],
    image: Project6,
  },
  {
    id: 10,
    title: "Ghaziabad Farmhouse Estate",
    client: "Private Farmhouse Owner",
    location: "Crossing Republik, Ghaziabad, UP",
    type: "Farmhouse Landscape Design",
    area: "14,000 sq ft",
    startDate: "Nov 2022",
    endDate: "Feb 2023",
    duration: "4 Months",
    year: "2023",
    status: "Completed",
    description:
      "Sprawling farmhouse landscape — heritage fruit orchard, organic kitchen garden, wildflower meadows, rustic stone pathways, wooden pergola with fire pit seating area, and a large central lawn bordered with native flowering shrubs.",
    tags: ["Farmhouse", "Orchard", "Organic Garden", "Ghaziabad"],
    image: Project7,
  },
  {
    id: 11,
    title: "Rohini Township Green Belt",
    client: "Residential Association",
    location: "Rohini, North Delhi",
    type: "Community Green Belt",
    area: "25,000 sq ft",
    startDate: "Apr 2022",
    endDate: "Oct 2022",
    duration: "7 Months",
    year: "2022",
    status: "Completed",
    description:
      "Large-scale community green belt across a Rohini township — avenue plantation with native shade trees, children's nature play zones, walking trail gardens, seasonal flowering borders, and a central community amphitheatre lawn.",
    tags: ["Community Garden", "Avenue Plantation", "Rohini", "Delhi"],
    image: Project8,
  },
  {
    id: 12,
    title: "Haridwar Wellness Retreat",
    client: "Wellness & Yoga Centre",
    location: "Rishikesh Road, Haridwar, Uttarakhand",
    type: "Wellness Garden Design",
    area: "8,000 sq ft",
    startDate: "Jan 2024",
    endDate: "Mar 2024",
    duration: "3 Months",
    year: "2024",
    status: "Completed",
    description:
      "Tranquil wellness garden for a yoga and meditation retreat on the banks of the Ganga — bamboo groves, medicinal plant walks, open-air meditation lawns, a healing herb garden, and a sensory water feature with natural stone detailing.",
    tags: ["Wellness Garden", "Meditation", "Bamboo Grove", "Haridwar"],
    image: Project10,
  },

  /* ── RUNNING — 3 projects ─────────────────────────────────── */
  {
    id: 13,
    title: "Serenity Sky Residences",
    client: "Premium Housing Society",
    location: "Sector 150, Noida, UP",
    type: "Residential Complex Landscape",
    area: "18,000 sq ft",
    startDate: "Dec 2025",
    endDate: "till july 2026",
    duration: "5 Months (Ongoing)",
    year: "2026",
    status: "Running",
    description:
      "Designing and executing landscaped entrance promenades, sensory children's garden zones, rooftop terrace retreats, and a community green amphitheatre for a prestigious premium housing society. Currently in Phase 2 — rooftop and terrace zones.",
    tags: ["Residential Complex", "Rooftop Garden", "Community Lawn", "Noida"],
    image: Project5,
  },
  {
    id: 14,
    title: "Gurugram Golf Estate Villa",
    client: "Private Residence",
    location: "DLF Golf Links, Gurugram, Haryana",
    type: "Luxury Villa Garden",
    area: "10,000 sq ft",
    startDate: "Oct 2025",
    endDate: "June 2025",
    duration: "8 Months (Ongoing)",
    year: "2026",
    status: "Running",
    description:
      "Luxury garden design for a villa adjacent to DLF Golf Links — private infinity lawn, imported ornamental grasses, a cabana garden with tropical planting, evening mood lighting system, and a sculptural water wall. Currently in Phase 3 — lighting and finishing.",
    tags: ["Luxury Villa", "Infinity Lawn", "Mood Lighting", "Gurugram"],
    image: Project4,
  },
  {
    id: 15,
    title: "The Willow Creek Township",
    client: "Integrated Township Developer",
    location: "Greater Noida West, UP",
    type: "Township Landscape Master Plan",
    area: "45,000 sq ft",
    startDate: "Nov 2025",
    endDate: "Jun 2026",
    duration: "8 Months (Ongoing)",
    year: "2026",
    status: "Running",
    description:
      "Comprehensive landscape master planning and execution for an integrated township — parks, jogging trails, water features, avenue plantations, themed gardens, children's zones, and full horticultural management protocols. Currently in Phase 2 — park zones and water features.",
    tags: ["Township", "Master Plan", "Parks", "Greater Noida"],
    image: Project3,
  },
];
const filters = ["All", "Completed", "Running"];

const stats = [
  { value: "100+",   label: "Projects Delivered",    sub: "Across India"    },
  { value: "10+",     label: "Years of Excellence",   sub: "Since 2019"                  },
  { value: "500+",   label: "Plant Varieties",       sub: "In Our Nursery"              },
  { value: "24/7",   label: "Support Available",     sub: "Call Us Anytime"             },
];


const clients = [
  { name: "Private Villas & Estates",  count: "10+",  icon: "🏡" },
  { name: "Hotels & Resorts",          count: "3+",  icon: "🏨" },
  { name: "Corporate Campuses",        count: "12+",  icon: "🏢" },
  { name: "Premium Residences",        count: "8+",  icon: "🌿" },
  { name: "Hospitals & Institutions",  count: "3+",  icon: "🏥" },
  { name: "Farmhouse Estates",         count: "6+",  icon: "🌳" },
  { name: "Colleges & Schools",        count: "5+",  icon: "🏛️" },
  { name: "Commercial Spaces",         count: "10+",  icon: "🏬" },
  { name: "Township & Housing",        count: "4+",  icon: "🏘️" },
];

export default function Projects() {
  const [activeFilter,  setActiveFilter]  = useState("All");
  const [activeProject, setActiveProject] = useState(null);
  const navigate = useNavigate();

  const filtered = activeFilter === "All"
    ? projects
    : projects.filter((p) => p.status === activeFilter);

  return (
    <div className="projects-page">
      <SEO path="/projects" />

      {/* ── HERO ── */}
      <div className="projects-hero">
        <div className="projects-hero__overlay" />
        <img src={Garden1} alt="Garvaana Projects — Luxury Landscape Design Delhi NCR" className="projects-hero__img" />
        <div className="projects-hero__content">
          <span className="projects-hero__tag">✦ Our Portfolio</span>
          <h1 className="projects-hero__title">Landscape Design Projects & Case Studies</h1>
          <p className="projects-hero__subtitle">
            A curated showcase of our finest landscape creations across Delhi NCR, UP, Haryana, Rajasthan & Uttarakhand.
          </p>
        </div>
      </div>

      {/* ── PROJECTS GRID ── */}
      <section className="projects-grid-section">
        <div className="projects-grid-section__inner">

          <div className="projects-grid-section__header">
            <span className="projects-section-tag">✦ Featured Work</span>
            <h2 className="projects-grid-section__title">Featured Projects</h2>
            <div className="gold-divider center" />
          </div>

          {/* Filters */}
          <div className="projects-filters">
            {filters.map((f) => (
              <button
                key={f}
                className={`projects-filter-btn ${activeFilter === f ? "projects-filter-btn--active" : ""}`}
                onClick={() => setActiveFilter(f)}
              >
                {f === "Running" && <span className="projects-filter-dot" />}
                {f}
                {f !== "All" && (
                  <span className="projects-filter-count">
                    {f === "Running"
                      ? projects.filter((p) => p.status === "Running").length
                      : projects.filter((p) => p.status === "Completed").length}
                  </span>
                )}
              </button>
            ))}
          </div>

          <div className="projects-grid">
            {filtered.map((project) => (
              <div
                key={project.id}
                className={`project-card ${project.status === "Running" ? "project-card--running" : ""}`}
                onClick={() => setActiveProject(project)}
              >
                <div className="project-card__image-wrap">
                  <img src={project.image} alt={`${project.title} — Garvaana Enterprise`} className="project-card__image" />
                  <div className="project-card__image-overlay" />
                  <span className={`project-card__status project-card__status--${project.status.toLowerCase()}`}>
                    {project.status === "Running" ? "● In Progress" : "✓ Completed"}
                  </span>
                  <span className="project-card__location">📍 {project.location}</span>
                </div>

                <div className="project-card__body">
                  <span className="project-card__type">{project.type}</span>
                  <h3 className="project-card__title">{project.title}</h3>
                  <p className="project-card__client">{project.client}</p>

                  <div className="project-card__meta">
                    <span>{project.area}</span>
                    <span>{project.duration}</span>
                    <span>{project.year}</span>
                  </div>

                  <div className="project-card__tags">
                    {project.tags.slice(0, 3).map((t, i) => (
                      <span key={i} className="project-card__tag">{t}</span>
                    ))}
                  </div>

                  <div className="project-card__cta">View Details →</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── PROJECT STATS STRIP ── */}
      <section className="projects-stats-strip">
        {stats.map((s, i) => (
          <div className="projects-stats-strip__item" key={i}>
            <span className="projects-stats-strip__value">{s.value}</span>
            <span className="projects-stats-strip__label">{s.label}</span>
            <span className="projects-stats-strip__sub">{s.sub}</span>
          </div>
        ))}
      </section>

      {/* ── CLIENT TYPES ── */}
      <section className="clients-showcase">
        <div className="clients-showcase__inner">
          <div className="clients-showcase__header">
            <span className="projects-section-tag">✦ Our Clientele</span>
            <h2 className="clients-showcase__title">Who Trusts Garvaana</h2>
            <div className="gold-divider center" />
            <p className="clients-showcase__subtitle">
              An exclusive portfolio of residential, commercial, hospitality and institutional
              clients across Delhi NCR and connected states who demand the finest in landscape design.
            </p>
          </div>

          <div className="clients-showcase__grid">
            {clients.map((c, i) => (
              <div className="clients-showcase__card" key={i}>
                <span className="clients-showcase__icon">{c.icon}</span>
                <div className="clients-showcase__count">{c.count}</div>
                <div className="clients-showcase__name">{c.name}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── STATS BAR ── */}
      <StatusBar />

      {/* ── CTA ── */}
      <section className="projects-cta">
        <div className="projects-cta__inner">
          <span className="projects-section-tag" style={{ marginBottom: "16px", display: "inline-block" }}>
            ✦ Start Your Project
          </span>
          <h2 className="projects-cta__title">Ready to Transform Your Space?</h2>
          <p className="projects-cta__text">
            Join hundreds of satisfied clients who trusted Garvaana Enterprise to create their dream outdoor spaces across India.
          </p>
          <div className="projects-cta__actions">
            <button className="btn-luxury"         onClick={() => navigate("/contact")}>Get a Free Quote</button>
            <button className="btn-luxury-outline" onClick={() => navigate("/gallery")}>View Full Gallery</button>
          </div>
        </div>
      </section>

      {/* ── MODAL ── */}
      {activeProject && (
        <div className="project-modal" onClick={() => setActiveProject(null)}>
          <div className="project-modal__box" onClick={(e) => e.stopPropagation()}>
            <button className="project-modal__close" onClick={() => setActiveProject(null)}>✕</button>

            <div className="project-modal__img-wrap">
              <img src={activeProject.image} alt={activeProject.title} className="project-modal__img" />
              <span className={`project-modal__badge project-modal__badge--${activeProject.status.toLowerCase()}`}>
                {activeProject.status === "Running" ? "● Currently In Progress" : "✓ Completed"}
              </span>
            </div>

            <div className="project-modal__body">
              <p className="project-modal__type">{activeProject.type}</p>
              <h2 className="project-modal__title">{activeProject.title}</h2>
              <p className="project-modal__location">📍 {activeProject.location}</p>

              <div className="project-modal__meta">
                <div><span>Client</span><strong>{activeProject.client}</strong></div>
                <div><span>Area</span><strong>{activeProject.area}</strong></div>
                <div><span>Started</span><strong>{activeProject.startDate}</strong></div>
                {activeProject.status === "Completed"
                  ? <div><span>Completed</span><strong>{activeProject.endDate}</strong></div>
                  : <div><span>Est. Completion</span><strong>{activeProject.endDate}</strong></div>
                }
                <div><span>Duration</span><strong>{activeProject.duration}</strong></div>
              </div>

              <p className="project-modal__desc">{activeProject.description}</p>

              <div className="project-modal__tags">
                {activeProject.tags.map((t, i) => (
                  <span key={i} className="project-card__tag">{t}</span>
                ))}
              </div>

              <button
                className="btn-luxury"
                style={{ marginTop: "24px", width: "100%", textAlign: "center" }}
                onClick={() => { setActiveProject(null); navigate("/contact"); }}
              >
                Start a Similar Project ✦
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}